module.exports = __webpack_public_path__ + "static/media/paso-1.c84fef16.png";